<div class="flex-vertical gap-16 width-100pc">
  <div class="flex-horizontal flex-center gap-16">
    <div>
      {{ totalCount }} <span *ngIf="totalCount > 1">fichiers allocation</span
      ><span *ngIf="totalCount < 2">fichier allocation</span>
    </div>
  </div>
  <div class="width-100pc">
    <oui-table *ngIf="!isLoading && dataSource.filteredData.length > 0">
      <table mat-table [dataSource]="dataSource" matSort #configSort="matSort">
        <ng-container *ngFor="let columnconfig of columnSelection" matColumnDef="{{ columnconfig.header }}">
          <ng-container *ngIf="columnconfig?.withSort">
            <th mat-header-cell *matHeaderCellDef mat-sort-header [disableClear]="true">
              {{ columnconfig.header }}
            </th>
          </ng-container>
          <ng-container *ngIf="!columnconfig?.withSort">
            <th mat-header-cell *matHeaderCellDef>
              {{ columnconfig.header }}
            </th>
          </ng-container>
          <td mat-cell *matCellDef="let config">
            <div>
              {{ displayColumnInfo(columnconfig, config) ?? '-' }}
            </div>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <ng-container>
          <tr
            [class.interactive]="true"
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            (click)="rowClick(row)"></tr>
        </ng-container>
      </table>
    </oui-table>
    <div class="etat-vide-container" *ngIf="isLoading || dataSource.filteredData.length === 0">
      <oui-etat-vide *ngIf="!isLoading" title="Aucun résultat" icon="live_help"></oui-etat-vide>
      <oui-loading *ngIf="isLoading" class="flex-horizontal flex-center justify-center"></oui-loading>
    </div>
  </div>
</div>
